module.exports = ".label1{border:none;box-shadow:none;padding:0px 0px;text-align:center}\n"